// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
export * from './LocalHeader';
export { type LocalHeaderProps } from './LocalHeader.types';
